import { showEstimatedAvailability as showEstimatedAvailabilityLegacy } from './transaction';

import { CheckImageType, Customer, DetailedTransaction, TransactionStatus } from '../data';

export function isCheckTransaction({ category }: DetailedTransaction): boolean {
  return category === 'Check Deposit' || category === 'Check Withdrawal';
}

export type CashbackStatus = 'earned' | 'pending' | undefined;

export const getCashbackProperties = (
  customer: Customer,
  earnedAmount: number,
  pendingAmount: number
): { cashbackStatus: CashbackStatus; cashbackAmount: number; cashbackMessage: string | undefined } => {
  let cashbackStatus: CashbackStatus;
  let cashbackAmount = 0;
  let cashbackMessage;

  if (!customer.isCashbackRewardsEligible) {
    return { cashbackStatus, cashbackAmount, cashbackMessage };
  }

  if (earnedAmount > 0) {
    cashbackStatus = 'earned';
    cashbackAmount = earnedAmount;
    cashbackMessage = undefined;
  } else if (pendingAmount > 0) {
    cashbackStatus = 'pending';
    cashbackAmount = pendingAmount;
    cashbackMessage = 'Rewards will be deposited into your account within 90 days.';
  }

  return { cashbackStatus, cashbackAmount, cashbackMessage };
};

export const getDisplayStatus = (status: TransactionStatus): string => {
  const statusMap: Record<TransactionStatus, string> = {
    [TransactionStatus.Pending]: 'Pending',
    [TransactionStatus.Settled]: 'Complete',
    [TransactionStatus.Voided]: 'Canceled',
  };
  return statusMap[status];
};

export function getCheckImageUrls(transaction: DetailedTransaction): {
  checkFrontImageUrl?: string;
  checkBackImageUrl?: string;
} {
  const checkImages = transaction.check?.images;
  const checkFrontImage = checkImages?.find(
    checkImage =>
      checkImage.type ===
      (transaction.category === 'Check Deposit Return' ? CheckImageType.ReturnCheckFront : CheckImageType.CheckFront)
  );
  const checkBackImage = checkImages?.find(
    checkImage =>
      checkImage.type ===
      (transaction.category === 'Check Deposit Return' ? CheckImageType.ReturnCheckBack : CheckImageType.CheckBack)
  );

  return {
    checkFrontImageUrl: checkFrontImage?.url,
    checkBackImageUrl: checkBackImage?.url,
  };
}

export function parseDescription(description: string): { description: string; accountNumber: string } {
  const match = /^(.*)(••••\d{4})$/.exec(description);

  if (match) {
    return {
      description: match[1].trimEnd(),
      accountNumber: match[2],
    };
  }

  return { description, accountNumber: '' };
}

function isMerchandiseReturn(transaction: DetailedTransaction): boolean {
  return transaction.bettermentCategory === 'Merchandise Return';
}

export function showEstimatedAvailability(transaction: DetailedTransaction): boolean {
  return showEstimatedAvailabilityLegacy(transaction) || isMerchandiseReturn(transaction);
}
